var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMortgagePurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#mortgagePurchaseSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.17 10.83-12 12A4 4 0 0 0 8 25.66V38c0 1.1.9 2 2 2h9a1 1 0 0 0 1-1v-7a4 4 0 1 1 8 0v7a1 1 0 0 0 1 1h9a2 2 0 0 0 2-2V25.66a4 4 0 0 0-1.17-2.83l-12-12a4 4 0 0 0-5.66 0Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mortgagePurchaseSvg",
    x1: 0,
    y1: 0.26,
    x2: 49.22,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3829"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgagePurchase);
export default __webpack_public_path__ + "static/media/MortgagePurchase.8a9d5a7b57b3c3ccd03e1bef263fdd2a.svg";
export { ForwardRef as ReactComponent };